export const AppoNavigationOptions = {
  back: {animated: true, animationDirection: 'back'},
  forward: {animated: true, animationDirection: 'forward'},
} as const;


export const ModalDismissTime = 500;
